<template>
  <div>
    <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" :name="$tx('hygl.voteManage.specifyDepart','指定部门')" rules="required">
    <!-- <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" name="指定部门" rules="required"> -->
      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
        <el-input v-show="vo.voteRange === 2" v-model="vo.personName" v-select-dialog="'suborg'" :placeholder="$tx('hygl.voteManage.specifyDepartPlaceholder','请选择指定部门')" org-level="2" readonly multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds" />
      </el-tooltip>
    </ValidationProvider>
    <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" :name="$tx('hygl.voteManage.specifyGroup','指定群组')" rules="required">
    <!-- <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" name="指定群组" rules="required"> -->
      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
        <el-input v-show="vo.voteRange === 3" v-model="vo.personName" v-select-dialog="'workgroup'" :placeholder="$tx('hygl.voteManage.specifyGroupPlaceholder','请选择指定群组')" readonly multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds2" />
      </el-tooltip>
    </ValidationProvider>
    <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" :name="$tx('hygl.voteManage.specifyPerson','指定人员')" rules="required">
    <!-- <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" name="指定人员" rules="required"> -->
      <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
        <el-input v-show="vo.voteRange === 4" v-model="vo.personName" v-select-dialog="'staff'" :placeholder="$tx('hygl.voteManage.specifyPersonPlaceholder','请选择指定人员')" readonly multiple="true" type="textarea" name="studyId" nametype="2" :root-org-code="vo.orgCode" />
      </el-tooltip>
    </ValidationProvider>
    <span v-if="canEdit===0" v-html="vo.personName" />
  </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectedIds = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                selected += node.name
                selectedIds += node.id + ','
            })
            this.$set(this.vo, 'personId', selectedIds.substring(0, selectedIds.length - 1))
            this.$set(this.vo, 'personName', selected)
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectedIds = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                selected += node.name
                selectedIds += node.id + ','
            })
            this.$set(this.vo, 'personId', selectedIds.substring(0, selectedIds.length - 1))
            this.$set(this.vo, 'personName', selected)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectedIds = ''

            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                selected += node.name
                selectedIds += node.id + ','
            })
            this.$set(this.vo, 'personName', selected)
            this.$set(this.vo, 'personId', selectedIds.substring(0, selectedIds.length - 1))
            this.$set(this.vo.passenger, 'selectedStaffs', selectedNodes)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
